import { render, staticRenderFns } from "./MerchantCashFees.vue?vue&type=template&id=67ff7966"
import script from "./MerchantCashFees.vue?vue&type=script&lang=js"
export * from "./MerchantCashFees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports